export const phoneNumber = new RegExp(/^\d{4}-?\d{4}$/);

export const usernameRegex = new RegExp(/^[A-Za-z0-9_]{6,20}$/);

export const passwordRegex = new RegExp(
  /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$&*]).{8,}/
);

export const identificacionRegex = {
  pattern: new RegExp(/(^\d{13}$)|(^[A-Z]\d{6}$)|(^\d{2}-\d{4}-\d{4}-\d{5}$)/)
    .source,
  title: "p. ej. 0101198700123, 01-0101-1987-00123 o C041957",
};

export const rtnRegex = {
  pattern: new RegExp(/^\d{14}$/).source,
  title: "p. ej. 01011987012345, son 14 dígitos, sin guiones ni espacios",
};

export const telefonoRegex = {
  pattern: new RegExp(/^2\d{3}-?\d{4}$/).source,
  title: "p. ej. 2442-3389, con o sin guiones",
};

export const celularRegex = {
  pattern: new RegExp(/^[389]\d{3}-?\d{4}$/).source,
  title: "p. ej. 9898-9595, 3381-3696 o 8886-8090, con o sin guiones",
};

export const coordenadasRegex = {
  pattern: new RegExp(
    /^-?(([0-9]|[1-8][0-9])(\.\d+)?|(90(\.0+)?)),\s-?(([0-9]|[1-9][0-9]|[1][0-7][0-9])(\.\d+)?|(180(\.0+)?))$/
  ).source,
  title: "p. ej. 15.783518367213972, -86.76581184662624",
};

export const correoElectronicoRegex = {
  pattern:
    /^[a-zA-Z](\.?[a-zA-Z0-9_\-])*@[a-zA-Z0-9]+([\._\-]?[a-zA-Z0-9])+\.[a-zA-Z]{2,}$/
      .source,
  title: "p. ej. nombredeusuario@email.com",
};

export const direccionWebRegex = {
  pattern: new RegExp(
    /^[a-z0-9]+([\-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
  ).source,
  title:
    "p. ej. mipaginaweb.com o www.nombredenegocio.com, sin el prefijo https:// o http://",
};

export const nombreCompletoRegex = {
  pattern: new RegExp(
    /^([A-ZÑÁÉÍÓÚÜ][a-zñáéíóúü]*\s)+([A-ZÑÁÉÍÓÚ][a-zñáéíóúü]*)$/
  ).source,
  title:
    "p. ej. José María Martínez, al menos un nombre y un apellido, nombres propios se escriben con letra mayúscula al principio, sin números ni caracteres especiales",
};
